function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M149.084 32.0277H32.9163C30.8902 32.0277 29.255 33.6629 29.255 35.6891C29.255 37.7152 30.8902 39.3504 32.9163 39.3504H149.084C151.11 39.3504 152.745 37.7152 152.745 35.6891C152.745 33.6629 151.11 32.0277 149.084 32.0277Z",
  fill: "#CEB896"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M149.084 60.0031H32.9163C30.8902 60.0031 29.255 61.6383 29.255 63.6645C29.255 65.6906 30.8902 67.3258 32.9163 67.3258H149.084C151.11 67.3258 152.745 65.6906 152.745 63.6645C152.745 61.6383 151.11 60.0031 149.084 60.0031Z",
  fill: "#CEB896"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M149.084 87.9785H32.9163C30.8902 87.9785 29.255 89.6137 29.255 91.6398C29.255 93.666 30.8902 95.3012 32.9163 95.3012H149.084C151.11 95.3012 152.745 93.666 152.745 91.6398C152.745 89.6137 151.11 87.9785 149.084 87.9785Z",
  fill: "#CEB896"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M160.707 0H21.2926C9.56211 0 0 9.56211 0 21.2926V108.951C0 120.682 9.56211 130.244 21.2926 130.244H119.011C120.042 130.244 121.037 130.706 121.677 131.523L153.243 171.478C154.487 173.042 156.3 173.895 158.184 173.895C158.895 173.895 159.605 173.789 160.316 173.54C162.911 172.651 164.582 170.27 164.582 167.532V129.888C174.464 128.04 182 119.331 182 108.951V21.2926C182 9.56211 172.438 0 160.707 0ZM174.677 108.951C174.677 116.558 168.492 122.814 160.885 122.921C158.895 122.957 157.259 124.592 157.259 126.582V164.795L127.4 127.009C125.338 124.414 122.281 122.921 118.975 122.921H21.2926C13.5789 122.921 7.32266 116.665 7.32266 108.951V21.2926C7.32266 13.5789 13.5789 7.32266 21.2926 7.32266H160.707C168.421 7.32266 174.677 13.5789 174.677 21.2926V108.951Z",
  fill: "#CEB896"
});

var SvgSvetovanjePodpora = function SvgSvetovanjePodpora(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSvetovanjePodpora, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/svetovanje-podpora.73b7692b.svg";
export { ForwardRef as ReactComponent };